import { TableUIProvider } from "../../contexts/TableUIContext";
import ExamScores from "./ExamScores";

export default function ExamScoresWrapper() {
    return (
        <TableUIProvider>
            <ExamScores />
        </TableUIProvider>
    );
}
